import React, { type ReactNode } from "react";

import { BadgeAlert } from "~/common/redesign-v1/icons";

/** Notice for form-level information. Kept separate from the form chrome to avoid importing its stylesheet elsewhere. */
export function PatientFormNotice({ children, testId }: { children: ReactNode; testId?: string }) {
  return (
    <div data-testid={testId} className="tw-flex tw-items-center tw-gap-2 tw-rounded-lg tw-border tw-border-solid tw-border-border tw-bg-transparent tw-p-3">
      <BadgeAlert className="tw-size-5 tw-shrink-0 tw-text-orange-500" aria-hidden />
      <p className="tw-m-0 tw-text-xs tw-font-normal tw-leading-4 tw-text-foreground">{children}</p>
    </div>
  );
}
